import {
  CalendarDateTime,
  getLocalTimeZone,
  toZoned,
} from "@internationalized/date";
import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { TextMap } from "features/CenterContent/RoleContent/GlobalEvents/types/responseSchema";
import { PeriodicFormDuration } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/formSchema";
import { VisibilityResponse } from "shared/form/visibilitySchema";

export type PreviewResponse = {
  internalContext: string | null;
  internalTitle: string | null;
  internalMessage: string | null;
  externalContext: string | null;
  externalTitle: string | null;
  externalMessage: string | null;
};

export type TrainIdentifierWithIncidentId = TrainIdentifier & {
  incidentId: string;
};

export function trainIdentifierIsEqual(
  first: TrainIdentifier,
  second: TrainIdentifier,
): boolean {
  return (
    first.identifier === second.identifier &&
    first.nominalDate === second.nominalDate &&
    first.countryCode === second.countryCode
  );
}

export type TrainIdentifierWithIncidentIdString =
  `${string}-${string}-${string}-${string}`;

export function trainIdentifierWithIncidentIdToString({
  incidentId,
  countryCode,
  identifier,
  nominalDate,
}: TrainIdentifierWithIncidentId): TrainIdentifierWithIncidentIdString {
  return `${incidentId}-${countryCode}-${identifier}-${nominalDate}`;
}

export type PreviewResponseBatch = {
  preview: PreviewResponse;
  train: TrainIdentifier;
}[];

export type InfrastructureEventCreatedResponse = {
  uuid: string;
  incidentId: string;
  texts: TextMap;
  visibility: VisibilityResponse;
};

export type Stop = {
  name: string;
  id: string;
};

export type Leg = {
  fromStop: Stop;
  toStop: Stop;
};
export const formatTime = (time: CalendarDateTime) => {
  const localTimeZone = getLocalTimeZone();
  return toZoned(time, localTimeZone).toString();
};
export const initialPeriodicDuration: PeriodicFormDuration = {
  type: "PERIODIC",
  rules: [],
};
